class TextCounter {
    constructor (theme, elem) {
        this.name = elem.id || this.constructor.name
        this._theme = theme
        this._elem = elem
        this._input = elem.nextElementSibling
    }
    onInit () {
        if (this._input.tagName === 'INPUT') {
            this._input.addEventListener('input', () => { this.onChange() })
            this._input.addEventListener('change', () => { this.onChange() })
        }
    }
    onChange () {
        let limit = this._input.maxLength
        this._elem.innerHTML = `${this._input.value.length}/${limit}`
    }
}

export default TextCounter



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/TextCounter.js